import React, { useState, useEffect } from 'react';
import Layout from '../Layout'
import { CiPhone } from "react-icons/ci";
import { CiMail } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { NavLink } from 'react-router-dom';
import { CiStar } from "react-icons/ci";
import { CiFacebook } from "react-icons/ci";
import { PiWhatsappLogoLight } from "react-icons/pi";
import { CiInstagram } from "react-icons/ci";
import { Country, State, City } from 'country-state-city';
import axios from 'axios';
import toast from 'react-hot-toast';
import API_BASE_URL from "../config.jsx";


export default function ContactUs() {
  const [rating, setRating] = useState(0);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");

  const notifyS = () => toast.success('Thanks for showing interest!');
  const notifyF = () => toast.error('Submission failed. Please try again.');


  const handleRating = (star) => {
    setRating(star);
  };


  const initialFormData = {
    user_name: '',
    email: '',
    phone: '',
    country: '',
    message: ''
  };
  const [formData, setFormData] = useState(initialFormData);
  const resetForm = () => {
    setFormData(initialFormData);
    setSelectedState(''); 
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setFormData(prev => ({ ...prev, country: e.target.value })); 
  };

  useEffect(() => {
    const indiaStates = State.getStatesOfCountry("IN");
    setStates(indiaStates);
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}clientLeads/create`, formData);
      console.log('API Response:',);
      if (response.data.statusCode) {
        notifyS();
        resetForm();
      } else {
        notifyF();
      }
    } catch (error) {
      console.error('Submission Failed:', error);
    }
  };


  return (
    <>

      <Layout>
        <div className="tp-page-area sec-mar">
          <div className="container-fluid custom-container">
            <div className="row">
              <div className="col-xl-12">
                <div className="tp-page-content">
                  <div className="tp-page-post">
                    <div data-elementor-type="wp-page" data-elementor-id="49" className="elementor elementor-49">
                      <div className="elementor-element elementor-element-0b613d3 e-con-full e-flex e-con e-parent" data-id="0b613d3" data-element_type="container">
                        <div className="elementor-element elementor-element-67f21b7 elementor-widget elementor-widget-tp-services" data-id="67f21b7" data-element_type="widget" data-widget_type="tp-services.default">
                          <div className="elementor-widget-container">


                            <section className="banner org_clr">
                              <div className="container ">
                                <div className="row gy-4 gy-sm-0 align-items-center justifyCenter">
                                  <div className="col-12  col-sm-12">
                                    <div className="banner__content">
                                      <h1 className="banner__title display-4 wow fadeInLeft textCenter" data-wow-duration="0.8s">Contact</h1>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </section>


                            <section className="feature feature--tertiary section">
                              <div className="container">
                                <div className="col-12 col-sm-12 col-xl-12">
                                  <div className="row">

                                    <div className="col-md-12 col-lg-12">
                                      <div className='mainContactDiv card--custom cstm_plan_card'>

                                        <div className="more-help"
                                          data-wow-duration="0.8s">
                                          <h3 className="cusTittle"
                                            data-wow-duration="0.8s ">Need more help?</h3>
                                          <div className="more-help__content">
                                            <div className="cus_card card card--small">
                                              <div className="cus_icon card--small-icon">
                                                <CiPhone className='contact_icons' />
                                              </div>
                                              <div className="card--small-content">
                                                <h5
                                                  className="card_title card--small-title">
                                                  Call Now</h5>
                                                <div className="gap-1 flex-column">
                                                  <p
                                                    className="card_text card--small-call dflex">
                                                    <NavLink to={"/contactUs"}>9749892861</NavLink>
                                                    &nbsp; <span>/</span> &nbsp;
                                                    <NavLink to={"/contactUs"}>8100615075</NavLink>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="cus_card card card--small">
                                              <div className="cus_icon card--small-icon">
                                                <CiMail className='contact_icons' />
                                              </div>
                                              <div className="card--small-content">
                                                <h5
                                                  className="card_title card--small-title">
                                                  Email Address</h5>
                                                <div className="gap-1 flex-column">
                                                  <p
                                                    className="card_text card--small-call">
                                                    <NavLink to={"/contactUs"}>Support@loansmoney.in</NavLink>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="cus_card card card--small">
                                              <div className="cus_icon card--small-icon">
                                                <CiLocationOn className='contact_icons' />
                                              </div>
                                              <div className="card--small-content">
                                                <h5
                                                  className="card_title card--small-title">
                                                  Location</h5>
                                                <div className="gap-1 flex-column">
                                                  <p
                                                    className="card_text card--small-call">
                                                    kolkata, New Town
                                                  </p>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="social mt_32">
                                              <NavLink to={"/"} className="btn_theme social_box ftr_scl_btn"><CiFacebook className='footer_icons' /></NavLink>
                                              <NavLink to={"/"} className="btn_theme social_box ftr_scl_btn"><PiWhatsappLogoLight className='footer_icons' /></NavLink>
                                              <NavLink to={"/"} className="btn_theme social_box ftr_scl_btn"><CiInstagram className='footer_icons' /></NavLink>
                                            </div>

                                          </div>
                                        </div>

                                        <div className="contact-from contactMdBdr">
                                          <h3 className="cusTittle" data-wow-duration="0.8s">Get in touch with us.</h3>

                                          <div className='pdrm'>

                                            <form
                                              onSubmit={handleSubmit}
                                              className="wpcf7-form init"
                                              aria-label="Contact form">

                                              <div className="d-flex flex-column gap-4">
                                                <div className="input-group">
                                                  <div className="input-single">
                                                    <label className="label" htmlFor="name">Name</label>
                                                    <input
                                                      type="text"
                                                      id="name"
                                                      name="user_name"
                                                      value={formData.user_name}
                                                      onChange={handleChange}
                                                      placeholder="Enter Your Name..."
                                                      className="form-control"
                                                      maxLength="400"
                                                      required
                                                    />
                                                  </div>

                                                  <div className="input-single">
                                                    <label className="label" htmlFor="email">Email</label>
                                                    <input
                                                      type="email"
                                                      id="email"
                                                      name="email"
                                                      value={formData.email}
                                                      onChange={handleChange}
                                                      placeholder="Enter Your Email..."
                                                      className="form-control"
                                                      maxLength="400"
                                                      required
                                                    />
                                                  </div>
                                                </div>

                                                <div className="input-group">
                                                  <div className="input-single">
                                                    <label className="label" htmlFor="phone">Phone</label>
                                                    <input
                                                      type="tel"
                                                      id="phone"
                                                      name="phone"
                                                      value={formData.phone}
                                                      onChange={handleChange}
                                                      placeholder="Enter Your Number..."
                                                      className="form-control"
                                                      maxLength="400"
                                                      required
                                                    />
                                                  </div>

                                                  <div className="input-single">
                                                    <label className="label" htmlFor="message">Select State:</label>
                                                    <select id="states" value={selectedState} onChange={handleStateChange} className='form-control'>
                                                      <option value="">Select a State</option>
                                                      {states.map((state) => (
                                                        <option key={state.id} value={state.name}>
                                                          {state.name}
                                                        </option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                </div>

                                                <div className="input-single">
                                                  <label className="label" htmlFor="message">Message</label>
                                                  <textarea
                                                    id="message"
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    placeholder="Enter Your Message..."
                                                    className="form-control"
                                                    rows="5"
                                                    maxLength="2000"
                                                    required
                                                  ></textarea>
                                                </div>
                                              </div>

                                              <div className="cnctMsgBt">
                                                <button
                                                  type="submit"
                                                  className="btn_theme mt_40 wpcf7-submit btn_clr"
                                                  id="submit"
                                                >
                                                  Send Message
                                                </button>
                                              </div>
                                            </form>

                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                    <div className="col-md-12 col-lg-12">
                                      <div className="elementor-element elementor-element-c35dac3 e-con-full e-flex e-con e-child"
                                        data-id="c35dac3" data-element_type="container">
                                        <div className="elementor-element elementor-element-0b9caed elementor-widget elementor-widget-tp-contact"
                                          data-id="0b9caed" data-element_type="widget"
                                          data-widget_type="tp-contact.default">
                                          <div className="elementor-widget-container">


                                            <div className="contact cus_box">
                                              <h3 className="cus_title title contact__title wow fadeInDown"
                                                data-wow-duration="0.8s">Get in touch with us.</h3>

                                              <div>
                                                <form
                                                  action="#"
                                                  method="post" className="wpcf7-form init"
                                                  aria-label="Contact form"
                                                  data-status="init">


                                                  <div className="d-flex flex-column gap-4">

                                                    <div className="rating-section">
                                                      <p className="rating-title">How would you rate our service?</p>
                                                      <div className="starsCstmCmt">
                                                        {[1, 2, 3, 4, 5].map((star) => (
                                                          <CiStar
                                                            key={star}
                                                            className={`review_star ${star <= rating ? "filled" : ""}`}
                                                            onClick={() => handleRating(star)}
                                                          />
                                                        ))}
                                                      </div>
                                                    </div>

                                                    <div className="input-single">
                                                      <label className="label"
                                                        for="message">Tell us about your experience</label>
                                                      <span className="wpcf7-form-control-wrap"
                                                        data-name="message"><textarea cols="30"
                                                          rows="5" maxlength="2000"
                                                          className="wpcf7-form-control wpcf7-textarea wpcf7-validates-as-required form-control"
                                                          id="message" aria-required="true"
                                                          aria-invalid="false"
                                                          placeholder="Leave your review or comments here..."
                                                          name="message"></textarea></span>
                                                    </div>
                                                  </div>

                                                  <div className='cnctMsgBt'>
                                                    <button type="btn"
                                                      className="btn_theme mt_40 wpcf7-form-control wpcf7-submit btn_clr">Submit</button>
                                                  </div>

                                                </form>
                                              </div>

                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </section>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}
